import Phaser from 'phaser';
import { SCENE_KEYS } from '../config';

export class FinalScene extends Phaser.Scene {
  constructor() { super({ key: SCENE_KEYS.FINAL }); }
  create(): void {
    const { width, height } = this.cameras.main;
    this.cameras.main.setBackgroundColor('#000000');
    this.add.text(width / 2, height / 4, 'PATRIA Y VIDA', {
      fontSize: '56px', fontFamily: 'Arial Black, sans-serif', color: '#ffcc00',
    }).setOrigin(0.5);
    const ct = this.add.text(width / 2, height / 2 + 120, 'PRESS ENTER', {
      fontSize: '18px', fontFamily: 'Arial, sans-serif', color: '#aaaaaa',
    }).setOrigin(0.5);
    this.tweens.add({ targets: [ct], alpha: 0.2, duration: 800, yoyo: true, repeat: -1 });
    this.input.keyboard?.on('keydown-ENTER', () => this.scene.start(SCENE_KEYS.MENU));
  }
}
